// src/components/Footer.js
import React from 'react';

function Footer() {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()} InkedBy-Steff</p>
      <p>Email: inkedbysteff@gmail.com</p>
      <p className="social-media">
        <a href="https://instagram.com/inkedby.steff" target="_blank" rel="noopener noreferrer">
          <img 
            src={process.env.PUBLIC_URL + '/assets/images/Instagram-Icon.png'} 
            alt="Instagram" 
          />
          <span>inkedbysteff</span>
        </a>
      </p>
    </footer>
  );
}

export default Footer;